import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import Cart from 'orders/Cart';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Cart />,
    document.querySelector('.cartApp'),
  )
})
